<template>
  <div>
    <div class=" px-5 mx-auto md:w-96 py-2">
      <Button class="flex w-full bg-blue-400">
        <router-link class="w-full" to="/menu/add">افزودن منو</router-link>
      </Button>
  
      <div v-if="menues.length">
        <MenuItem
            v-for="menu in menues"
            :key="menu.id"
            :id="menu.id"
            :name="menu.name"
            :catCount="menu.catCount"
            :baseurl="baseurl"
            :selected="menu.isActivate"
            @deleted="deleteMenu"
        />
      </div>
  
      <div class="mt-28" v-else>
        <h1 class="text-center text-gray-400">منویی ذخیره نشده است.</h1>
      </div>
    </div>
  
    <TransitionRoot appear :show="deleteModal" as="template">
      <Dialog as="div" @close="closeDeleteModal">
        <div class="fixed inset-0 z-10 overflow-y-auto">
          <div class="min-h-screen px-4 text-center">
            <TransitionChild
                as="template"
                enter="duration-300 ease-out"
                enter-from="opacity-0"
                enter-to="opacity-100"
                leave="duration-200 ease-in"
                leave-from="opacity-100"
                leave-to="opacity-0"
            >
              <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-50"/>
            </TransitionChild>
  
            <span class="inline-block h-screen align-middle" aria-hidden="true">
              &#8203;
            </span>
  
            <TransitionChild
                as="template"
                enter="duration-300 ease-out"
                enter-from="opacity-0 scale-95"
                enter-to="opacity-100 scale-100"
                leave="duration-200 ease-in"
                leave-from="opacity-100 scale-100"
                leave-to="opacity-0 scale-95">
              <div
                  class="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                <DialogTitle
                    as="h3"
                    class="text-lg font-medium leading-6 text-gray-900 text-right">
                  حذف منو
                </DialogTitle>
                <div class="mt-2">
                  <p class="text-sm text-gray-500 text-right">
                    آیا از حذف منو مطمئن هستید ؟
                  </p>
                </div>
  
                <div class="mt-4">
                  <button
                      type="button"
                      class="bg-gray-300 rounded-lg px-4 p-2 text-sm"
                      @click="closeDeleteModal">
                    لغو
                  </button>
                  <button
                      type="button"
                      class="bg-red-500 rounded-lg px-4 p-2 text-sm text-white mr-4"
                      @click="confirmDelete">
                    حذف
                  </button>
                </div>
              </div>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
    </div>
  </template>
  
  <script>
  //import Button from "@/components/General/VButton";
  import Button from "@/components/Button";
  import { useToast } from 'vue-toastification'
  const toast = useToast()
  import MenuItem from "@/components/MenuCard";
  import {DeleteMenu,GetStoreBySlug} from "@/API/API.js";
  import store from '../store';
  import {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay,
    DialogTitle,
  } from "@headlessui/vue";
 
  export default {
    name: "MenuList",
    components: {MenuItem, Button, Dialog, DialogOverlay, DialogTitle, TransitionRoot, TransitionChild},
    data() {
      return {
        menues: [],
        deleteModal: false,
        deleteId: '',
        baseurl:'',
        LanguageId:1
      }
    },
    async created() {
      this.$Progress.start()
      await this.getMenuList()
      this.$Progress.finish()
    },
    methods: {
      async getMenuList() {
        console.log(store.getters.slug)
        console.log(1200);
        //let result = (await GetStoreBySlug(store.getters.slug)).data.result
        let result = (await GetStoreBySlug(store.getters.slug)).data
        
        console.log(result);
        //this.menues=result.screenMenus    // added rahim
        this.menues=result.screenMenus
        store.commit('SET_SLUG',result.slug );
        //console.log(this.menues);
        //console.log(store.UserAppDomain);
        //console.log(process.env.VUE_APP_UserDOMAIN);
        this.baseurl=process.env.VUE_APP_UserDOMAIN;
      },
      deleteMenu(id) {
        this.deleteModal = true
        this.deleteId = id
      },
      confirmDelete() {
        //console.log(this.deleteId)
        //console.log(store.getters.slug)
        DeleteMenu(store.getters.slug,this.deleteId)
        .then(async () => {
              await this.getMenuList()
              this.deleteModal = false
            })
        .catch((e) =>{ 
          console.log(e)
           //toast.error(e.response.data.result)
           toast.error(e.response.data)
           
        })
      
      },
     closeDeleteModal() {
        this.deleteModal = false
      }    
 },

  }
  </script>
  
  